import React from 'react';
import './HoverDiv.scss';
import { useGlobalContext } from '../../Context';

function HoverDiv() {
  const { isHovered, hoveredDiv } = useGlobalContext();
  const showDiv = () => {
    hoveredDiv.current.style.opacity = 1;
  };
  return (
    <div
      ref={hoveredDiv}
      className={`hover ${isHovered ? 'show' : ''}`}
      onMouseOver={showDiv}
    >
      <p>Drag me</p>
    </div>
  );
}

export default HoverDiv;
